import { render, staticRenderFns } from "./PersistTypeSmsView.vue?vue&type=template&id=f3982f56&"
import script from "./PersistTypeSmsView.vue?vue&type=script&lang=ts&"
export * from "./PersistTypeSmsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports